export default [
  {
    header: 'Dashboards',
    icon: 'HomeIcon',
    children: [
      {
        title: 'Base',
        route: 'dashboard-base',
        icon: 'ShoppingCartIcon',
      },
      // {
      //   title: 'Analytics',
      //   route: 'dashboard-analytics',
      //   icon: 'ActivityIcon',
      // },
    ],
  },
]
